<template>
  <div>
    <base-crud
      crudName="Filiais"
      newText="Nova Filial"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="true"
      :dataForm="dataForm"
    ></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "branchesTable",
      pages: [],
      url: "",
      columns: [
        "id",
        "description",
        "address",
        "number",
        "neighborhood",
        "city",
        "state",
        "actions",
      ],
      tableData: [
        "id",
        "description",
        "address",
        "number",
        "neighborhood",
        "city",
        "state",
      ],
      options: {
        sortable: [
          "id",
          "description",
          "address",
          "number",
          "neighborhood",
          "city",
          "state",
        ],
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          "id",
          "description",
          "address",
          "number",
          "neighborhood",
          "city",
          "state",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          description: "Descrição",
          address: "Endereço",
          number: "Número",
          neighborhood: "Bairro",
          city: "Cidade",
          state: "Estado",
          actions: "Ações",
        },
        templates: {},
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["cities", "states"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "branches/",

      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        description: "description",
        address: "address",
        number: "number",
        neighborhood: "neighborhood",
        city: "cities[title]",
        state: "states[title]",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Branches/Crud.vue